import {GenexLMSModel} from "@/models/lms/GenexLMSModel";
import GenexHelperMixins from "@/mixins/GenexHelperMixins";
import Module from "@/models/lms/Module";
import Course from "@/models/lms/Course";

export default class CourseModule extends GenexLMSModel {
    static entity = 'course-modules'

    static fields() {
        return {
            id: this.attr(null),
            module_id: this.attr(null),
            course_id: this.attr(null),
            module: this.belongsTo(Module, 'module_id'),
            course: this.belongsTo(Course, 'course_id'),
            is_restricted: this.attr(null),
            created_at: this.attr(""),
            updated_at: this.attr(""),
            order: this.attr(null),
        }
    }

    static FetchAll({page = 1, limit = 15}, query = {}, relationships = []) {
        return this.api().get(`/course-modules`, {
                ...GenexHelperMixins.methods.DefaultLMSHeadersAndBaseUrl(),
                params: {
                    ...{
                        page: page, limit: limit, with: relationships
                    }, ...(query !== {} ? query : {}),
                },
                dataTransformer: ({data: {data}}) => {
                    return GenexHelperMixins.methods.NormalizeRecursive(data);
                },
            }
        )
    }

}
